const getters = {
  isPhoneVerified(state) {
    let verified = false;
    if (state.userData.phoneVerified) {
      verified = true;
    }
    return verified;
  },
  sideBarOpened(state) {
    return state.sideBarOpened;
  },
  getUser(state) {
    return state.user;
  },
  getUserData(state) {
    return state.userData;
  },
  isUser(state) {
    return !!state.user;
  },
  getError(state) {
    return state.error;
  },
  getDatasets(state) {
    return state.datasets;
  },
  getNotificationsCount(state) {
    return state.notificationsCount;
  },
  accessToken(state) {
    const token = state.user.accessToken ? state.user.accessToken : null;
    return token;
  },
};

export default getters;
